/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
window.onload = function(){
const collectionBGs = document.querySelectorAll(".collection-bg__image img")

if(collectionBGs.length > 0){
  collectionBGs.forEach(collectionBG => {
    const bgImage = collectionBG.getAttribute("src")
    console.log(bgImage)
    collectionBG.closest(".collection-bg__image").style.backgroundImage = "url('"+bgImage+"')";
  })
}
}
*/



// Omnisend Popup Font Override
(function OmnisendFontOverride(){
  try {
    var headingFont = 'Jost, sans-serif';
    var bodyFont = 'Poppins, sans-serif';

    function applyFontToOmnisend(rootElement) {
      if (!rootElement) return;

      try {
        // Apply heading fonts - h2 for main title
        var headingSelectors = ['h2'];
        var headingNodes = rootElement.querySelectorAll(headingSelectors.join(','));
        headingNodes.forEach(function(node){
          node.style.setProperty('font-family', headingFont, 'important');
          node.style.setProperty('font-weight', '600', 'important'); // Semi Bold
        });

        // Apply body fonts - h3 for description text, plus other elements
        var bodySelectors = ['h3','p','span','label','li','a','input','textarea','small','strong','em','div'];
        var bodyNodes = rootElement.querySelectorAll(bodySelectors.join(','));
        bodyNodes.forEach(function(node){
          // Skip if it's already a heading (h2)
          if (node.tagName.toLowerCase() !== 'h2') {
            node.style.setProperty('font-family', bodyFont, 'important');
            node.style.setProperty('font-weight', '300', 'important'); // Light
          }
        });

        // Apply button fonts - use heading font for stronger CTA
        var buttonSelectors = ['button','[type="submit"]'];
        var buttonNodes = rootElement.querySelectorAll(buttonSelectors.join(','));
        buttonNodes.forEach(function(node){
          node.style.setProperty('font-family', headingFont, 'important');
          node.style.setProperty('font-weight', '600', 'important');
        });
      } catch(e) {
        console.warn('⚠️ Omnisend font apply failed:', e);
      }
    }

    function scanAndApply(context) {
      var containers = (context || document).querySelectorAll('[class^="omnisend-form-"], [class*=" omnisend-form-"]');
      containers.forEach(function(container){ applyFontToOmnisend(container); });
    }

    // Initial pass once DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ scanAndApply(); });
    } else {
      scanAndApply();
    }

    // Observe future injections from Omnisend
    var observer = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(node){
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && (node.matches('[class^="omnisend-form-"]') || node.matches('[class*=" omnisend-form-"]'))) {
            applyFontToOmnisend(node);
          } else {
            // Scan subtree in case the container was added deeper
            scanAndApply(node);
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {
    console.warn('⚠️ Omnisend font override initialization failed:', e);
  }
})();